<div><mat-form-field appearance="outline" class="search-filter">
    <mat-label>Sök</mat-label>
    <input matInput [(ngModel)]="searchTerm" (keyup)="filterSelectableValuesByQuery()" placeholder="Sök"
      class="search-input">
    <mat-icon matSuffix>search</mat-icon>
  </mat-form-field>
</div>

<app-filter-button label="Område" [allValues]="this.allProductionTechnicianAreas"
  [(selectedValues)]="this.filterValues.productionTechnicianArea"
  (selectedValuesChange)="applyFilter()"></app-filter-button>
<app-filter-button label="Maskintyp" [allValues]="this.allMachineTypes"
  [(selectedValues)]="this.filterValues.machineType" (selectedValuesChange)="applyFilter()"></app-filter-button>
<app-filter-button label="Produktionsledare" [allValues]="this.allProductionLeaders"
  [(selectedValues)]="this.filterValues.productionLeader" (selectedValuesChange)="applyFilter()"></app-filter-button>
<app-filter-button label="Status" [allValues]="this.allStatuses" [(selectedValues)]="this.filterValues.status"
  (selectedValuesChange)="applyFilter()"></app-filter-button>
<app-filter-button label="Ägartyp" [allValues]="this.allOwnerTypes" [(selectedValues)]="this.filterValues.ownerType"
  (selectedValuesChange)="applyFilter()"></app-filter-button>
<app-filter-button label="Kranspetskoordinat, högprecision" [allValues]="this.allHighPrecisionCraneTipCoordinateValues"
  [(selectedValues)]="this.filterValues.hasHighPrecisionCraneTipCoordinate"
  (selectedValuesChange)="applyFilter()"></app-filter-button>
<app-filter-button label="RTK" [allValues]="this.allRtkValues" [(selectedValues)]="this.filterValues.hasRtk"
  (selectedValuesChange)="applyFilter()"></app-filter-button>
<app-filter-button label="Skolskotare" [allValues]="this.allSchoolForwarderValues"
  [(selectedValues)]="this.filterValues.isSchoolForwarder" (selectedValuesChange)="applyFilter()"></app-filter-button>
<app-filter-button label="Grotskotare" [allValues]="this.allGrotForwarderValues"
  [(selectedValues)]="this.filterValues.isGrotForwarder" (selectedValuesChange)="applyFilter()"></app-filter-button>
<app-filter-button label="Demomaskin" [allValues]="this.allDemoMachineValues"
  [(selectedValues)]="this.filterValues.isDemoMachine" (selectedValuesChange)="applyFilter()"></app-filter-button>
<app-filter-input-chips [(selectedValues)]="this.filterValues" (selectedValuesChange)="applyFilter()"
  [tableId]="'machine-table'"></app-filter-input-chips>